import { useMemo, useState, useCallback } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { addYears } from 'date-fns/addYears';
import { fontSizes } from 'app/typography';
import {
  DatePicker as KizenDatePicker,
  IntlProvider,
  defaultLocale,
} from 'components/Kizen/DateRangePicker';
import Button from 'components/Button';

const ButtonsWrapper = styled.div`
  border-top: 1px solid var(--color-border-medium);
  padding: 13px 15px;
  display: flex;
  justify-content: ${({ showClearButton }) =>
    showClearButton ? 'space-between' : 'flex-end'};
  > button {
    height: unset;
    font-size: ${fontSizes.small};
    line-height: 1;
  }
`;

function getCalendarDate([value]) {
  const currentDate = value || new Date();
  return [currentDate, addYears(new Date(), 100)];
}

const DatePicker = ({
  value = null,
  locale = null,
  onSelect,
  onHide,
  showClearButton = true,
  showApplyButton = true,
}) => {
  const { t } = useTranslation();
  const calendarValue = useMemo(() => (value ? [value] : []), [value]);

  const [calendarDate, setCalendarDate] = useState(() =>
    getCalendarDate(calendarValue)
  );
  const handleChangeCalendarDate = useCallback(
    (index, date) => {
      const nextCalendarDate = [...calendarDate];
      nextCalendarDate[index] = date;
      setCalendarDate(nextCalendarDate);
    },
    [calendarDate]
  );

  return (
    <>
      <IntlProvider locale={locale || defaultLocale}>
        <KizenDatePicker
          value={calendarValue}
          calendarDate={calendarDate}
          onChangeCalendarDate={handleChangeCalendarDate}
          onSelect={onSelect}
        />
      </IntlProvider>
      {(showClearButton || showApplyButton) && (
        <ButtonsWrapper showClearButton={showClearButton}>
          {showClearButton && (
            <Button
              noSpace
              variant="text"
              color="red"
              onClick={() => onSelect(null)}
            >
              {t('Clear')}
            </Button>
          )}
          {showApplyButton && (
            <Button noSpace variant="text" onClick={onHide}>
              {t('Apply')}
            </Button>
          )}
        </ButtonsWrapper>
      )}
    </>
  );
};

export default DatePicker;
